export const userGetters = {
  getTest(state) {
    return state.test
  },
  getLoggedIn(state) {
    return state.loggedin
  },
  getNotRegistered(state) {
    return state.notregistered
  },
  getNewUser(state) {
    console.log(
      'GET NEW USER (%s) (%j)',
      state.secondaryuser.su_phone && state.secondaryuser.su_phone !== '',
      state.secondaryuser
    )
    if (state.secondaryuser.su_phone && state.secondaryuser.su_phone !== '') {
      // user exist since su_phone is not empty
      //  console.log('GET NEW USER: returning false')
      return false
    }
    // console.log('GET NEW USER: returning true')
    return true
  },
  getDisplayName: (state) => {
    return state.displayname
  },
  getPrimaryUserSelected(state) {
    return state.primaryselected
  },
  getPrimaryUserData(state) {
    return state.primaryuser
  },
  getUserId(state) {
    return state.userid
  },
  getEmail(state) {
    return state.email
  },
  getAffilitation(state) {
    return state.affilitation
  },
  getSecondaryUserData(state) {
    return state.secondaryuser
  },
  getEngageUser(state) {
    console.info('getEngageUser called (%j)', state.engageuser)
    return state.engageuser
  },
  getIsMemory(state) {
    let pu = state.primaryuser
    if (pu.pu_service === 'memory') {
      return true
    }
    return false
  },
  getIsRehab(state) {
    let pu = state.primaryuser
    if (pu.pu_service === 'rehab') {
      return true
    }
    return false
  },
  getIsStructure(state) {
    let pu = state.primaryuser
    if (pu.pu_service === 'structure') {
      return true
    }
    return false
  }
}
